export const AchieveIntroductions = [
  {
    icon: "gem",
    title: "Stable Currency",
    description:
      "Asset-backed decentralized currency without volatility. Stable by design and without borders."
  },
  {
    icon: "globe",
    title: "Multi-Collateral Backed",
    description:
      "Every aUSD is backed in excess by multiple asset collaterals. Safety mechanisms and incentives are in place to counter volatility, ensure security and resilience."
  },
  {
    icon: "fighter jet",
    title: "Influence by Ownership",
    description:
      "Acala Network Token holders have the responsibility to govern the network's operation, make a decision on its future, and share earnings."
  }
];
